@let formControl = this.control();
<form class="tw-flex tw-h-full" (submit)="onClickSearch($event)">
  <div
    class="tw-flex-1 tw-flex tw-gap-1 tw-items-center tw-border-zinc-300 tw-border-y-[1px] tw-border-l-[1px] tw-rounded-l-lg tw-overflow-hidden tw-px-3"
  >
    <input
      data-1p-ignore
      [formControl]="formControl"
      class="tw-flex-1 tw-w-full tw-h-full tw-outline-none tw-text-sm tw-min-w-0 xs:tw-text-[12px]"
      type="text"
      [placeholder]="placeholder()"
    />
    <button
      mat-ripple
      type="button"
      class="tw-grid tw-place-items-center tw-h-5 tw-w-5 tw-min-w-5 tw-text-white tw-bg-zinc-600 tw-rounded-full"
      (click)="onClickClear()"
    >
      <app-svg-icon src="/assets/images/cross.svg" class="tw-h-[14px] tw-w-[14px]" />
    </button>
  </div>
  <button
    mat-ripple
    (click)="onClickSearch($event)"
    type="submit"
    class="tw-h-full tw-tracking-[0.25em] tw-indent-[0.25em] tw-bg-secondary hover:tw-bg-grey tw-text-white tw-py-2 tw-px-4 tw-inline-flex tw-items-center tw-rounded-r-lg"
  >
    <span class="xs:tw-text-[12px]">検索</span>
  </button>
</form>
